import { ref, reactive, onMounted, onBeforeUnmount } from 'vue'
import { useResizeObserver } from './resizeObserver'

export function useCustomChart(callbackDraw, options = {}, init = true) {
  const canvasWrap = ref(null)
  const canvasInfo = reactive({})
  const observer = ref()
  function initCanvas() {
    if (!canvasWrap.value) return
    const { width, height } = canvasWrap.value.getBoundingClientRect()
    const canvas = canvasWrap.value.children[0]
    
    // set canvas size
    canvas.style.width = `${width}px`
    canvas.style.height = `${height}px`
    canvas.width = width * 2
    canvas.height = height * 2
    canvasInfo.padding = options.padding
    canvasInfo.contentWidth = canvas.width - ( canvasInfo.padding * 2 )
    canvasInfo.contentHeight = canvas.height - ( canvasInfo.padding * 2 )
    if (options.gap) {
      canvasInfo.cellWidth = (canvasInfo.contentWidth - (options.gap * (options.columns - 1))) / options.columns
      canvasInfo.cellHeight = (canvasInfo.contentHeight - (options.gap * (options.rows - 1))) / options.rows
      canvasInfo.gap = options.gap
    } else {
      canvasInfo.cellWidth = (canvasInfo.contentWidth) / options.columns
      canvasInfo.cellHeight = (canvasInfo.contentHeight) / options.rows
    }
  }

  function getContext() {
    const canvas = canvasWrap.value.children[0]
    return canvas.getContext('2d')
  }

  function initCustomChart() {
    observer.value = useResizeObserver(() => {
      if (!canvasWrap.value) return
      initCanvas()
      callbackDraw(canvasInfo, canvasWrap.value.children[0].getContext('2d'))
    })
    if (canvasWrap.value) {
      observer.value?.observe(canvasWrap.value)
    }
  }

  onMounted(() => init ? initCustomChart() : '')
  onBeforeUnmount(() => {
    if (canvasWrap.value) {
      observer.value?.unobserve(canvasWrap.value)
    }
  })
  return {
    canvasWrap,
    getContext,
    initCustomChart,
  }
}